import { type Branded, brand } from '../Branded';

export type PositiveNumber = Branded<number, 'positiveNumber'>;

export function asPositive(value: number): PositiveNumber {
  if (!isPositive(value)) {
    throw new Error(`Expected a positive finite number, got ${value}`);
  }
  return brand<PositiveNumber>(value);
}

export function isPositive(value: number): value is PositiveNumber {
  return value > 0 && Number.isFinite(value);
}
